var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import ClickAwayListener from "react-click-away-listener";
import { IToolbarButtonActiveContentType, } from "../../types";
import { ToolbarButtonStatefulControl } from "./toolbar-button-stateful-control";
import { ToolbarButtonActiveStateContent } from "./toolbar-button-active-state-content";
import { useKeyboardDropDownNavigation } from "../../hooks/hooks";
import { ToolbarButtonContainer } from "./toolbar-button-container";
import { useUuid } from "../../../common/hooks/useUuid";
import { useToolbarContentItemIdStore } from "../../hooks/useToolbarContentItemIdStore";
export var ToolbarButtonStateful = function (props) {
    switch (props.activeStateContentType) {
        case IToolbarButtonActiveContentType.HEADLESS:
            return _jsx(ToolbarButtonStatefulHeadless, __assign({}, props));
        case IToolbarButtonActiveContentType.CONTAINER:
            return _jsx(ToolbarButtonContainer, __assign({}, props));
        default:
            return _jsx(ToolbarButtonWithVisibleContent, __assign({}, props));
    }
};
var ToolbarButtonStatefulHeadless = function (_a) {
    var _b;
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    var _c = React.useState(false), isExpanded = _c[0], setIsExpanded = _c[1];
    // If isSelected is not passed, use isExpanded
    var isSelected = (_b = props.isSelected) !== null && _b !== void 0 ? _b : isExpanded;
    return (_jsxs("div", __assign({ className: "toolbar-control-wrapper" }, { children: [_jsx(ToolbarButtonStatefulControl, __assign({}, props, { isSelected: isSelected, onClick: function () {
                    setIsExpanded(function (s) { return !s; });
                    onClick && onClick();
                } })), props.ActiveStateContent && isSelected && (_jsx("div", __assign({ className: "hidden" }, { children: _jsx(props.ActiveStateContent, { close: function () {
                        setIsExpanded(false);
                    } }) })))] })));
};
var ToolbarButtonWithVisibleContent = function (_a) {
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    var activeStateContentType = props.activeStateContentType;
    var _b = React.useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var _c = useKeyboardDropDownNavigation({
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        activeStateContentType: activeStateContentType,
    }), menuReferenceElement = _c.menuReferenceElement, setMenuReferenceElement = _c.setMenuReferenceElement, onKeyDown = _c.onKeyDown;
    var _d = React.useState(null), buttonContentReferenceElement = _d[0], setButtonContentReferenceElement = _d[1];
    if (activeStateContentType === IToolbarButtonActiveContentType.MODAL &&
        props.id) {
        return _jsx(ToolbarButtonModal, __assign({ onClick: onClick }, props));
    }
    return (_jsx(ClickAwayListener, __assign({ onClickAway: function () {
            if (activeStateContentType === IToolbarButtonActiveContentType.DROPDOWN) {
                setIsExpanded(false);
            }
        } }, { children: _jsxs("div", __assign({ className: "toolbar-control-wrapper" }, { children: [_jsx(ToolbarButtonStatefulControl, __assign({}, props, { isSelected: isExpanded, setButtonContentReferenceElement: setButtonContentReferenceElement, onKeyDown: onKeyDown, onClick: function () {
                        setIsExpanded(function (s) { return !s; });
                        onClick && onClick();
                    } })), _jsx(ToolbarButtonActiveStateContent, __assign({ isExpanded: isExpanded, setIsExpanded: setIsExpanded, buttonContentReferenceElement: buttonContentReferenceElement, onKeyDown: onKeyDown, setMenuReferenceElement: setMenuReferenceElement, menuReferenceElement: menuReferenceElement, onClick: onClick }, props))] })) })));
};
var ToolbarButtonModal = function (_a) {
    var _b;
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    var uuid = useUuid([]);
    var id = (_b = props.id) !== null && _b !== void 0 ? _b : uuid;
    var _c = React.useState(false), isExpanded = _c[0], setIsExpanded = _c[1];
    var _d = useToolbarContentItemIdStore(), expandedItemId = _d.expandedItemId, setExpandedItemId = _d.setExpandedItemId, clearExpandedItemId = _d.clearExpandedItemId;
    useEffect(function () {
        setIsExpanded(id === expandedItemId);
    }, [id, expandedItemId]);
    var activeStateContentType = props.activeStateContentType;
    var _e = useKeyboardDropDownNavigation({
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        activeStateContentType: activeStateContentType,
    }), menuReferenceElement = _e.menuReferenceElement, setMenuReferenceElement = _e.setMenuReferenceElement, onKeyDown = _e.onKeyDown;
    var _f = React.useState(null), buttonContentReferenceElement = _f[0], setButtonContentReferenceElement = _f[1];
    return (_jsxs("div", __assign({ className: "toolbar-control-wrapper" }, { children: [_jsx(ToolbarButtonStatefulControl, __assign({}, props, { isSelected: isExpanded, onClick: function () {
                    if (isExpanded) {
                        clearExpandedItemId();
                    }
                    else {
                        setExpandedItemId(id);
                    }
                    setIsExpanded(function (s) { return !s; });
                    onClick && onClick();
                } })), _jsx(ToolbarButtonActiveStateContent, __assign({ isExpanded: isExpanded, setIsExpanded: setIsExpanded, buttonContentReferenceElement: buttonContentReferenceElement, onKeyDown: onKeyDown, setMenuReferenceElement: setMenuReferenceElement, menuReferenceElement: menuReferenceElement, onClick: onClick }, props))] })));
};
ToolbarButtonModal.displayName = "ToolbarButtonModal";
